_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'views/custom-field/custom-field-card-detail-badge-view'
Dates = require 'lib/dates'
DateEditorView = require 'views/custom-field/date-editor-view'
moment = require 'moment'
PopOver = require 'views/lib/pop-over'
t = require('views/internal/teacup-with-helpers')()
Util = require 'lib/util'

module.exports = class CustomFieldDateCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ icon, name, text, editable, color } = {}) ->
    t.h3 '.card-detail-item-header', ->
      t.icon icon
      t.text name

    if editable
      t.a '.card-detail-badge.is-clickable.js-custom-field-detail-badge' + color, { href: '#', title: text }, ->
        if text
          t.text text
        else
          t.span '.icon-sm.icon-add'
    else
      t.span '.card-detail-badge' + color, { title: text }, ->
        t.text text

  getBadgeText: ->
    if date = @customFieldItem?.get('value')?.date
      moment(new Date(date)).calendar()
    else
      ''

  events:
    'click .js-custom-field-detail-badge': 'editCustomFieldBadge'

  editCustomFieldBadge: (e) ->
    Util.stop(e)
    @track()

    PopOver.toggle
      elem: @$(e.target).closest('.js-custom-field-detail-badge')
      view: DateEditorView
      options: { @model, @modelCache, customFieldItem: @customFieldItem, customField: @customField }



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-date-card-detail-badge-view.coffee